<template>
  <div>
    <h2 class="mb-3 flex items-center page-title-tooltiped">
      {{ $t('Report templates') }}

      <icon-info-circle :text="$t('feature-explanation.report-template')" />
    </h2>
    <upgrade-ad v-if="isOnFreePlan"
                :message="$t('upgrade-ad.cb-stage3-customize')"
                :is-vertical="true"
                :classes="['upgrade-ad--cb-stage3-customize']"
    />
    <ul class="report-templates -mx-6 text-80">
      <li
        v-for="template in reportTemplates"
        :key="template.id"
        :class="{
          selected: template.id === selectedReportTemplate.id,
        }"
        class="px-5"
        @click="$emit('select', template)"
      >
        <div class="inner-wrapper flex py-4">
          <div class="flex-1" style="line-height:24px;">
            {{ template.data.title }}
          </div>

          <button v-if="!!template.id" class="ml-3 text-60 btn btn-small-icon"
                  @click.stop="$emit('edit', template)">
            <EditIcon />
          </button>

          <button v-if="!!template.id" class="ml-3 text-60 btn btn-small-icon"
                  @click.stop="$emit('delete', template)">
            <DeleteIcon />
          </button>
        </div>
      </li>
    </ul>

    <button
      class="text-primary font-semibold inline-block mt-6"
      @click="$emit('add')"
    >
      <starred-ad-item :is-starred="!hasFeature('customReports')">
        {{ $t('Add new report template') }}
      </starred-ad-item>
    </button>
  </div>
</template>

<script>
  import DeleteIcon from '@/_legacy/views/ChecklistBuilder/Icons/DeleteIcon.vue';
  import EditIcon from '@/_legacy/views/ChecklistBuilder/Icons/EditIcon.vue';
  import authMixin from '@/_legacy/mixins/authMixin';
  import IconInfoCircle from '@/_legacy/components/Icons/IconInfoCircle';
  import { StarredAdItem } from '@/ui/components/upgrade/StarredAdItem';
  import { UpgradeAd } from '@/ui/components/upgrade/UpgradeAd';

  export default {
    name: 'ReportTemplateSelector',

    components: {
      UpgradeAd,
      StarredAdItem,
      DeleteIcon,
      EditIcon,
      IconInfoCircle,
    },

    mixins: [
      authMixin,
    ],

    props: {
      reportTemplates: {
        type: Array,
        required: true,
      },
      selectedReportTemplate: {
        type: Object,
        required: true,
      },
    },
  };
</script>
